// ============================================================================
// diagnoza.js — SHIRITI QË TREGON PSE PREKJET NUK BËJNË ASGJË
//
//   ⚠ I PËRKOHSHËM. Hiqet para lansimit. Shih `NDEZUR` më poshtë.
//
// ---------------------------------------------------------------------------
// PROBLEMI QË E LINDI
//
// 27 gusht: te iPhone-i dhe te APK-ja e Android-it aplikacioni hapet, pamja del
// e plotë, hyrja me Google punon — dhe pastaj asnjë prekje nuk bën asgjë. Te
// shfletuesi i njëjti kod punon pa asnjë ankesë.
//
// Kur pamja mungon, dihet ku të shihet: `main.jsx` e ka prej kohësh kapësin që
// e shkruan gabimin e nisjes te `#root`-u bosh. Por këtu `#root`-u nuk është
// bosh. Aplikacioni u montua. Prandaj ai kapës hesht — me të drejtë.
//
// ---------------------------------------------------------------------------
// PSE NUK MJAFTON KONSOLA
//
// Konsola e një aplikacioni të instaluar shihet vetëm me Safari Web Inspector
// (iOS) ose me `chrome://inspect` mbi një ndërtim debug me kabllo (Android).
// Të dyja janë vegla që duhen mësuar në një moment ku ne duam vetëm një fakt.
//
// Ky skedar e shkruan atë fakt drejt në ekran. Ti prek, dhe shiriti të thotë
// çfarë ndodhi. Një pamje ekrani nga telefoni mjafton.
//
// ---------------------------------------------------------------------------
// ÇFARË MASIM, DHE PSE PIKËRISHT KËTO
//
// «Nuk ndodh asgjë» nuk është një gjendje e vetme. Janë katër, dhe secila ka
// një zgjidhje krejt tjetër. Shiriti i ndan:
//
//  1. Prekja nuk arrin fare te faqja
//     → nuk shfaqet asnjë rresht. Faji është te WebView-i, jo te kodi.
//
//  2. Prekja arrin, por e kap një element tjetër nga ai që ti sheh
//     → rreshti tregon një element që s'e prite. Mbi butonin rri një shtresë e
//       padukshme. Ky është shkaku më i shpeshtë kur pamja duket normale.
//
//  3. `pointerdown` vjen, `click` nuk vjen kurrë
//     → prekja nis dhe humbet rrugës. Zakonisht dikush thërret
//       `preventDefault()` te `touchstart`, ose `touch-action` e ndal.
//
//  4. `click` vjen te elementi i duhur dhe prapë s'ndodh asgjë
//     → ngjarja mbërriti; dështoi kodi ynë. Atëherë lexojmë rreshtin e gabimit,
//       që shiriti e shfaq gjithashtu.
//
// Shiriti shfaq edhe emrin e paketës `assets/index-XXXXXXXX.js`. Ai emër
// ndryshon me çdo ndërtim. Nëse pas një ndërtimi të ri emri mbetet i njëjti,
// atëherë telefonit i është dhënë paketa e vjetër — dhe kemi kërkuar për ditë
// të tëra një gabim që s'ekziston më te kodi. `ios.command` e ruan pikërisht
// nga kjo; ky rresht e vërteton në pajisje.
//
// ---------------------------------------------------------------------------
// AI VETË NUK GUXON TA PRISHË ATË QË MAT
//
// Kutia rri me `pointer-events: none`. Pa atë rresht ajo do të bëhej vetë
// shtresa që i ha prekjet, dhe do të «zbulonte» një defekt që e solli vetë.
//
// Të gjithë dëgjuesit janë `capture: true` dhe `passive: true`: dëgjojnë në
// zbritje, para se kushdo tjetër të ndalojë gjë, dhe premtojnë se s'do të
// thërrasin kurrë `preventDefault()`.
// ============================================================================

import { lexoZonen } from "./zonaESigurt"; // matja e zonës — një burim i vetëm

// ── Çelësi ─────────────────────────────────────────────────────────────────
// Vendose `false` (ose fshije skedarin dhe rreshtin e importit te `main.jsx`)
// para se aplikacioni t'u shkojë familjeve. Ky shirit është për ne, jo për ta.
// FIKUR më 28 gusht 2026. Ky shirit u ndërtua për pyetjen "pse prekjet nuk bëjnë
// asgjë", dhe ajo pyetje mori përgjigje: prekjet ishin në rregull — aplikacioni
// ishte i vdekur, dhe ajo që dukej në ekran ishte korniza e fundit para vdekjes.
// Fajtori doli `BiometricAuth.checkBiometry()`. Shiriti nuk ka më çfarë të masë,
// dhe dy shirita njëkohësisht poshtë ekranit mbulojnë njëri-tjetrin.
const NDEZUR = false;

// Sa rreshta mbahen në pamje. Më shumë se kaq e mbulojnë ekranin.
const RRESHTA = 7;

// Zona e sigurt matet te `zonaESigurt.js` — një burim i vetëm, sepse pikërisht
// kopjimi i asaj matjeje nëpër skedarë e krijoi defektin që po ndjekim.
// Kthen të tria vlerat, që të mos hamendësohet cila po fiton:
//   env  = ajo që jep vetë sistemi
//   përf = ajo që del pas korrigjimit tonë, pra ajo që sheh syri
function matZonen() {
  try {
    const z = lexoZonen();
    const n = (v) => (v == null ? "?" : Math.round(v));
    return `env ${n(z.envLart)} · përf ${n(z.perfLart)} · dpr ${z.dpr}`;
  } catch (_e) { return "s'u mat dot"; }
}

export function nisDiagnozen() {
  const eshteNative =
    typeof window !== "undefined" &&
    window.Capacitor &&
    typeof window.Capacitor.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform();

  // ÇELËSI, i ndarë më dysh më 29 gusht 2026.
  //
  // `NDEZUR` u fik kur pyetja e parë mori përgjigje, dhe ashtu duhet të mbetet:
  // askush nga familja s'duhet ta shohë këtë shirit. Por bashkë me të humbi
  // edhe e vetmja mënyrë për të parë një numër nga te vetë telefoni — dhe sot
  // pikërisht një numër na duhej (sa e madhe është zona e sigurt te iPhone-i).
  //
  // Prandaj `?diagnoza=1` tani e ndez GJITHMONË, edhe kur çelësi është i fikur.
  // Askush nuk e shkruan atë adresë rastësisht, ndaj asgjë s'rrezikohet — dhe
  // ne kemi një dritare hetimi që s'kërkon as Xcode, as kabllo, as rindërtim.
  const kerkuar =
    typeof window !== "undefined" &&
    window.location &&
    /[?&]diagnoza=1/.test(window.location.search);

  if (kerkuar) { /* kërkesë e shprehur — vazhdo */ }
  else if (!NDEZUR) return;
  else if (!eshteNative) return;

  const rreshtat = [];
  let kuti = null;
  let trupi = null;

  function nderto() {
    if (kuti) return;
    kuti = document.createElement("div");
    kuti.setAttribute("data-diagnoza", "1");
    kuti.style.cssText = [
      "position:fixed",
      "left:0",
      "right:0",
      "bottom:0",
      "z-index:2147483647",
      "pointer-events:none", // ← rreshti që e mban të ndershëm
      "background:rgba(10,8,6,.92)",
      "color:#f2ede3",
      "font:11px/1.45 ui-monospace,Menlo,monospace",
      "padding:8px 10px calc(8px + env(safe-area-inset-bottom))",
      "max-height:46vh",
      "overflow:hidden",
      "white-space:pre-wrap",
      "word-break:break-word",
    ].join(";");
    trupi = document.createElement("div");
    kuti.appendChild(trupi);
    document.body.appendChild(kuti);
  }

  function shkruaj(rresht) {
    rreshtat.push(rresht);
    while (rreshtat.length > RRESHTA) rreshtat.shift();
    nderto();
    trupi.textContent = rreshtat.join("\n");
  }

  // ── Si e emërtojmë një element ───────────────────────────────────────────
  // Emri i etiketës vetëm nuk mjafton: gjysma e faqes janë `DIV`. Klasa e parë
  // dhe përmasat e bëjnë të njohshëm. `position` dhe `z-index` shtohen sepse
  // pikërisht ato e bëjnë një element shtresë mbi të tjerët.
  function emri(el) {
    if (!el) return "asgjë";
    if (el === document.body) return "BODY";
    let s = el.tagName;
    if (el.id) s += "#" + el.id;
    const kl = (el.className && String(el.className).trim().split(/\s+/)[0]) || "";
    if (kl) s += "." + kl.slice(0, 24);
    try {
      const st = getComputedStyle(el);
      const r = el.getBoundingClientRect();
      s += ` ${Math.round(r.width)}×${Math.round(r.height)}`;
      if (st.position === "fixed" || st.position === "absolute") s += ` ${st.position}`;
      if (st.zIndex && st.zIndex !== "auto") s += ` z=${st.zIndex}`;
      if (st.pointerEvents === "none") s += " pe=none";
      if (parseFloat(st.opacity) < 0.5) s += ` op=${st.opacity}`;
    } catch (_e) { /* asgjë */ }
    return s;
  }

  function mbiRrjedhe(el) {
    try {
      const p = getComputedStyle(el).position;
      return p === "fixed" || p === "absolute" || p === "sticky";
    } catch (_e) {
      return false;
    }
  }

  // ── Prekja ───────────────────────────────────────────────────────────────
  //
  // `sipër` është elementi që ndodhet vërtet nën gishtin tënd, pyetur nga vetë
  // faqja. `cak` është ai që shfletuesi ia dërgoi ngjarjes. Kur të dy ndryshojnë,
  // e kemi gjetur: mbi butonin rri diçka tjetër.
  let pikaEFundit = 0;
  let priteshKlikimi = false;

  function prekje(e) {
    const t = (e.touches && e.touches[0]) || e;
    const x = t.clientX, y = t.clientY;
    const siper = document.elementFromPoint(x, y);
    const cak = e.target;
    const njejte = siper === cak;
    pikaEFundit = Date.now();
    priteshKlikimi = true;

    let rresht =
      `▸ ${e.type} @${Math.round(x)},${Math.round(y)}\n` +
      `  cak:   ${emri(cak)}`;
    if (!njejte) rresht += `\n  SIPËR: ${emri(siper)}   ← ndryshe nga caku`;
    shkruaj(rresht);

    // Nëse klikimi s'vjen brenda gjysmë sekonde, prekja humbi rrugës.
    setTimeout(() => {
      if (priteshKlikimi) {
        priteshKlikimi = false;
        shkruaj("  ✗ klikimi s'erdhi kurrë (prekja u ndal rrugës)");
      }
    }, 600);
  }

  function klikim(e) {
    priteshKlikimi = false;
    const ms = pikaEFundit ? Date.now() - pikaEFundit : 0;
    shkruaj(`  ✓ click ${ms}ms → ${emri(e.target)}`);
  }

  try {
    document.addEventListener("pointerdown", prekje, { capture: true, passive: true });
    document.addEventListener("click", klikim, { capture: true, passive: true });
  } catch (_e) { /* asgjë */ }

  // ── Gabimet e kodit tonë ─────────────────────────────────────────────────
  // Kapësi te `main.jsx` shkruan vetëm kur `#root` mbeti bosh. Ky shkruan edhe
  // kur aplikacioni u montua dhe pastaj u thye — pikërisht rasti ynë.
  window.addEventListener("error", (e) => {
    const m = (e && e.error && e.error.message) || (e && e.message) || String(e);
    shkruaj("✗ GABIM: " + String(m).slice(0, 220));
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e && e.reason;
    const m = (r && (r.message || r.error_description)) || String(r);
    shkruaj("✗ PREMTIM I THYER: " + String(m).slice(0, 220));
  });

  // ── Kontrolli i parë, dy sekonda pas nisjes ──────────────────────────────
  //
  // Pyetja: a ka diçka që e mbulon gjithë ekranin? Marrim pesë pika larg njëra
  // tjetrës. Nëse në të pesta ndodhet i njëjti element, ai është një shtresë
  // mbi gjithçka — dhe s'ka nevojë ta prekësh fare për ta ditur.
  setTimeout(() => {
    try {
      const w = window.innerWidth, h = window.innerHeight;
      const pikat = [
        [w * 0.5, h * 0.25],
        [w * 0.2, h * 0.5],
        [w * 0.8, h * 0.5],
        [w * 0.5, h * 0.75],
        [w * 0.5, h * 0.5],
      ];
      const gjetjet = pikat.map(([x, y]) => document.elementFromPoint(x, y));

      // I njëjti element në të pesta pikat do të thoshte shtresë mbi gjithçka —
      // por vetëm nëse ai element është përmbajtje. Kur faqja është bosh, në të
      // pesta pikat del `HTML` ose `BODY`, dhe ajo s'është shtresë: ajo është
      // mungesë. Të dyja duhen thënë, por jo me të njëjtat fjalë.
      const i = gjetjet[0];
      const bosh = i === document.documentElement || i === document.body;
      const njejti = !bosh && gjetjet.every((g) => g && g === i);
      const asgjeSPara = bosh && gjetjet.every((g) => g && g === i);

      const paketa =
        (document.querySelector('script[src*="assets/"]') || {}).src || "—";

      shkruaj(
        `paketa: ${String(paketa).split("/").pop()}\n` +
        `ekrani: ${w}×${h}\n` +
        // 29 gusht 2026 — te iPhone-i koka e dritareve dilte afërsisht tri herë
        // më e lartë se ç'duhet. Dyshimi ishte te zona e sigurt; por dyshimi
        // nuk është matje. Ky rresht e tregon vlerën e VËRTETË që përdor faqja,
        // aty te telefoni, pa kabllo dhe pa Xcode.
        `zona lart: ${matZonen()}\n` +
        (njejti
          // Një enë e lartë (p.sh. vetë `#root`) del në të pesta pikat pa qenë
          // fare shtresë. Shenjën e alarmit e meriton vetëm ajo që rri e
          // shkëputur mbi rrjedhën e faqes — `fixed` ose `absolute`.
          ? (mbiRrjedhe(i) ? "⚠ MBULON GJITHÇKA:\n  " : "në të pesta pikat:\n  ") + emri(i)
          : asgjeSPara
          ? "⚠ asnjë përmbajtje në asnjërën nga pesë pikat"
          : `sipër në mes: ${emri(gjetjet[4])}`)
      );
    } catch (_e) { /* asgjë */ }
  }, 2000);
}
